const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/insights/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { compactDateFilterSchema, compactPicklistFilterSchema } from '@/lib/zod-schemas/common/compactFilterSchemas';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';

/**
 * Validates compact groupBy format: groupBy1 or groupBy1_groupBy2
 * Examples: team, plan, team_plan, plan_itemType
 */
const compactGroupBySchema = z.string().regex(/^(team|plan|itemType|integration)(_(?:team|plan|itemType|integration))?$/, 'Invalid groupBy format. Expected: groupBy or groupBy1_groupBy2 (e.g., team, plan, team_plan)').optional();
export const insightsSearchSchema = z.object({
  insightId: z.preprocess(v => v === '' || v === undefined ? undefined : Number(v), z.number().int().positive()).optional(),
  containerId: z.preprocess(v => v === '' || v === undefined ? undefined : Number(v), z.number().int().positive()).optional(),
  planId: compactPicklistFilterSchema,
  teamId: compactPicklistFilterSchema,
  statusId: compactPicklistFilterSchema,
  itemTypeId: compactPicklistFilterSchema,
  integrationId: compactPicklistFilterSchema,
  expectedStartDateTime: compactDateFilterSchema,
  expectedFinishDateTime: compactDateFilterSchema,
  latestFinishDateTime: compactDateFilterSchema,
  orderBy: z.enum(['priority', 'expectedStartDateTime', 'expectedFinishDateTime', 'latestFinishDateTime']).optional(),
  orderDir: z.enum(['asc', 'desc']).optional(),
  groupBy: compactGroupBySchema
});
export const insightsDeliverablesSearchSchema = insightsSearchSchema.and(itemPanelSearchSchema);
export const Route = createFileRoute('/(app)/org/$org/insights')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(insightsDeliverablesSearchSchema)
});